import * as Yup from 'yup';

const alpanumericRegex = /^[a-zA-Z0-9]*$/;
// match only number
const reNumber = /^[0-9]*$/;
// a regex that allows to insert and alfanumeric string followed by a new line
const alphanumericRegexWithNewLine = /^(?:[a-zA-Z0-9]+\n)*[a-zA-Z0-9]+(?:\n)?$/;

const emailRegex = /^[a-zA-Z\s]+ <[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}>$/; // equal

export const optionalValidationSchema = Yup.object().shape({
  protocolsType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  protocolsIvaType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  vatNumbersType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  ragioneSocialeType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  codiceFornitoreType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  inoviceNumberType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  vendorNameType: Yup.object().shape({
    label: Yup.string(),
    value: Yup.number(),
  }),
  protocols: Yup.string().when('protocolsType', {
    is: (val) => val.value === 2,
    then: Yup.string().matches(alphanumericRegexWithNewLine, 'invalid_protocols'),
    otherwise: Yup.string().matches(alpanumericRegex, 'invalid_protocols'),
  }),
  protocolsIva: Yup.string().when('protocolsIvaType', {
    is: (val) => val.value === 2,
    then: Yup.string().matches(alphanumericRegexWithNewLine, 'invalid_iva_protocols'),
    otherwise: Yup.string().matches(alpanumericRegex, 'invalid_iva_protocols'),
  }),
  codiceFornitore: Yup.string().when('codiceFornitoreType', {
    is: (val) => val.value === 2,
    then: Yup.string().matches(alphanumericRegexWithNewLine, 'invalid_codice_fornitore'),
    otherwise: Yup.string().matches(alpanumericRegex, 'invalid_codice_fornitore'),
  }),
  vatNumbers: Yup.string().when('vatNumbersType', {
    is: (val) => val.value === 2,
    then: Yup.string().matches(alphanumericRegexWithNewLine, 'invalid_vat_numbers'),
    otherwise: Yup.string().matches(alpanumericRegex, 'invalid_vat_numbers'),
  }),
  protocolsFrom: Yup.string().when('protocolsType', {
    is: (val) => val.value === 3,
    then: Yup.string().matches(alpanumericRegex, 'invalid_protocols'),
  }),
  protocolsTo: Yup.string().when('protocolsType', {
    is: (val) => val.value === 3,
    then: Yup.string().matches(alpanumericRegex, 'invalid_protocols'),
  }),
  protocolsIvaFrom: Yup.string().when('protocolsIvaType', {
    is: (val) => val.value === 3,
    then: Yup.string().matches(reNumber, 'invalid_iva_protocols'),
  }),
  protocolsIvaTo: Yup.string().when('protocolsIvaType', {
    is: (val) => val.value === 3,
    then: Yup.string().matches(reNumber, 'invalid_iva_protocols'),
  }),
  fromAdr: Yup.string().when('fromAdrType', {
    is: (val) => val.value === 0,
    then: Yup.string().matches(emailRegex, 'invalid_from_adr'),
    otherwise: Yup.string(),
  }),
});

export const replaceNewLineWithArray = (string: string): string[] | undefined => {
  if (!string) {
    return undefined;
  }
  return string.split('\n').filter((item) => item !== '');
};

export type FilePosition = 'Acquisition' | 'Working queue' | 'Dispatcher' | 'Archived' | undefined;
export const FilePositionTypes = {
  acquisition: 'Acquisition',
  workingQueue: 'Working queue',
  dispatcher: 'Dispatcher',
  archived: 'Archived',
};
